import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import categoryTree from "../../Domain/ProductTree";
import * as Widget from "../Widget";
import * as Icon from "../Icon";

function getDisplay(node, label) {
  if (node.name === label) {
    return node.display || node.name;
  }

  if (node.children) {
    for (let subtreeNode of node.children) {
      let display = getDisplay(subtreeNode, label);
      if (display) {
        return display;
      }
    }
  }
}

function splitLabel(label) {
  let result = [];
  let accLabel = "";
  for (let c of label) {
    if (c === "-") {
      result.push(accLabel);
    }
    accLabel += c;
  }
  result.push(accLabel);
  return result;
}

const Wrapper = styled.div`
  display: flex;

  & a {
    text-decoration: none;
    font-size: 14px;
    color: #818181;
    cursor: pointer;
  }

  & a::after {
    content: ">";
    margin: 0 10px;
  }
`;

class BreadCrumbs extends React.Component {
  render() {
    let { label, pathPrefix } = this.props;

    if (label === "root" || label === "") {
      return (
        <Wrapper>
          <Widget.Row align="center">
            <Icon.Location
              color="#818181"
              size={14}
              style={{ marginRight: 5 }}
            />
            <Link to={`${pathPrefix}`}>全部商品</Link>
          </Widget.Row>
        </Wrapper>
      );
    }

    let crumbs = splitLabel(label).map(name => ({
      name,
      display: getDisplay(categoryTree[0], name)
    }));

    return (
      <Wrapper>
        <Widget.Row align="center">
          <Icon.Location color="#818181" size={14} style={{ marginRight: 5 }} />
          <Link to={`${pathPrefix}`}>全部商品</Link>
        </Widget.Row>

        {crumbs.map(crumb => (
          <Link key={crumb.name} to={`${pathPrefix}/${crumb.name}`}>
            {crumb.display}
          </Link>
        ))}
      </Wrapper>
    );
  }
}

export default BreadCrumbs;
